import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


const TOTAL_EGGS = 7;

export const unlockEgg = (id) => {
  const discovered = JSON.parse(localStorage.getItem("easter-eggs") || "[]");

  if (!discovered.includes(id)) {
    discovered.push(id);
    localStorage.setItem("easter-eggs", JSON.stringify(discovered));

    console.log(`Egg unlocked: ${id}`);
  }

  console.log(`Easter Eggs Discovered: ${discovered.length}/7`);

  if (discovered.length === TOTAL_EGGS) {
    triggerFinalAchievement();
  }
};

const triggerFinalAchievement = () => {
  if (localStorage.getItem("easter-master")) return;

  localStorage.setItem("easter-master", "true");

  const overlay = document.createElement("div");

overlay.className = `
fixed inset-0 flex items-center justify-center
bg-black/40 backdrop-blur-sm
z-[999]
`;

overlay.innerHTML = `
  <div class="
    glass border-gradient
    px-10 py-8
    rounded-2xl
    text-center
    shadow-2xl
    animate-fade-in
  ">
    <div class="text-xs font-mono text-primary tracking-widest mb-2">
      ACHIEVEMENT UNLOCKED
    </div>
    <div class="text-lg font-semibold">
      Full Stack Explorer
    </div>
    <div class="text-xs text-muted-foreground mt-3 font-mono">
      All hidden systems discovered.
    </div>
  </div>
`;

document.body.appendChild(overlay);

setTimeout(() => {
  overlay.style.opacity = "0";
  overlay.style.transition = "opacity 0.4s ease";
  setTimeout(() => overlay.remove(), 2000);
}, 3000);

};